import { render } from "./ProductInfo.vue?vue&type=template&id=7b88b51d&scoped=true"
import script from "./ProductInfo.vue?vue&type=script&lang=js"
export * from "./ProductInfo.vue?vue&type=script&lang=js"

import "./ProductInfo.vue?vue&type=style&index=0&id=7b88b51d&scoped=true&lang=css"

import exportComponent from "/Volumes/Work/1Gate/1Gate/1gate_check_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b88b51d"]])

export default __exports__